export const DAILY_QUOTES = [
  "A soundboard a day keeps the silence away.",
  "Who needs therapy when you have a soundboard?",
  "Warning: prolonged use may result in your coworkers questioning your sanity.",
  "Scientifically proven to lower workplace productivity by 73%.",
  "Every great conversation starts with the perfect sound effect.",
  "The person who invented the mute button never met this soundboard.",
  "If a soundboard plays in a Discord call and nobody laughs, did it even happen?",
  "Your neighbors called. They said turn it up.",
  "Side effects may include: uncontrollable laughter, noise complaints, and getting fired.",
  "We don't make the sounds. We just make them dangerously accessible.",
  "Somewhere, a meeting is being ruined by this soundboard. You're welcome.",
  "This is what the internet was made for.",
  "Disrupting conversations since 2024.",
  "The wizard is never late. He plays precisely the sound he means to.",
  "Press play. Assert dominance.",
  "Why use words when sounds do the trick?",
  "Not responsible for any friendships lost due to excessive sound spamming.",
  "Finally, a website your parents would be proud of.",
  "Turning awkward silences into awkward sounds since day one.",
  "Your volume is probably too low.",
  "Banned in 3 Discord servers. And counting.",
  "If you're reading this, you should be playing sounds instead.",
  "Batteries not included. Volume knob not installed.",
  "Earbuds recommended. Dignity not guaranteed.",
  "The only skill you need on your resume.",
  "Making group chats worse, one sound at a time.",
  "We put the 'fun' in 'fundamentally annoying.'",
  "100% organic, free-range, artisanal sound clips.",
  "Voted most likely to get you kicked from a voice chat.",
  "The dark arts of audio, at your fingertips.",
  "Now available in surround sound. Your family will love it.",
  "The spells are the sounds. The wand is your mouse.",
  "Professional-grade procrastination toolkit.",
  "May your sounds be loud and your mute button forgotten.",
  "Parental advisory: explicit soundboard.",
  "Where every click is a cry for attention.",
  "Built different. Sounds worse.",
  "This is not a phase, mom. This is a lifestyle.",
  "Instructions unclear. Played sound at full volume in church.",
  "The council of wizards approves this message.",
  "Caution: exposure may cause permanent immaturity.",
  "Because typing 'lol' wasn't cutting it anymore.",
  "Your headphones are in, right? ...Right?",
  "The secret ingredient is always chaos.",
  "Making the internet louder, one click at a time.",
  "The only magic you'll ever need.",
  "You could be doing something productive right now. But here we are.",
  "Powered by poor decisions and good vibes.",
  "The wizard's handbook says nothing about volume limits.",
  "No refunds. No regrets. No indoor voices.",
];

/** The quote of the day — stable for a given calendar day, rotates at UTC midnight. */
export function getDailyQuote(): string {
  const d = new Date();
  const day = Math.floor(d.getTime() / 86_400_000);
  return DAILY_QUOTES[day % DAILY_QUOTES.length];
}
